export default {
	checkData (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'reservation_data/check_data', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/ReservationData.js